import withSession from "grandus-lib/utils/session";
import useWebInstance from "grandus-lib/hooks/useWebInstance";
import { useRouter } from 'next/router'
import { reqApiHost, reqGetHost } from "grandus-lib/utils";
import { USER_CONSTANT, CART_CONSTANT } from "grandus-lib/constants/SessionConstants";

import Link from "next/link";
import { get } from "lodash";
import RegisterForm from "components/forms/Register";
import { Button, Result } from "antd";
import styles from "./auth/auth.module.scss";
import useUser from "grandus-lib/hooks/useUser";
import {useTranslation} from "next-i18next";
import {fetchTranslations} from "utils/fetches";

const Register = ({ user, cart,  apiHost, host }) => {
  const { t } = useTranslation();

  const { user: userFront } = useUser({
    redirectTo: "/",
    redirectIfFound: true,
  });

  const { webInstance, settings, domain } = useWebInstance();
  const facebokLoginEnabled = get(settings, 'facebook_login_enabled');
  const googleLoginEnabled = get(settings, 'google_login_enabled');
  const router = useRouter();

  if (user || userFront) {
    return (
      <div className="container guttered">
        <Result
          status="success"
          title={"Úspešné prihlásenie"}
          subTitle={`Vitajte späť ${get(
            user,
            "fullName",
            get(userFront, "fullName")
          )}`}
          extra={[
            <Link key={"signin-button-1"} href="/odhlasenie" as={`/odhlasenie`}>
              <Button>{t("Odhlásenie")}</Button>
            </Link>,
            <Link key={"signin-button-2"} href="/" as={`/`}>
              <Button>{t("Domovská stránka")}</Button>
            </Link>,
          ]}
        />
      </div>
    );
  }

  return (
    <div className={styles.auth}>
      <div className={`${styles.col} ${styles.second} ${styles.signup}`}>
        <div>
          <Link href="/" as={`/`}>
            <a className={styles.backButton}>
              {t("Späť")}
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11 6L16 11L11 16" stroke="black" strokeLinecap="round" strokeLinejoin="round"/><path d="M15 11L5 11" stroke="black" strokeLinecap="round"/></svg>
            </a>
          </Link>

          <h3>{t("Zaregistrujte sa")}</h3>
          <p>{t("Vytvorte si účet na portáli a využívajte všetky výhody vytvoreného konta")}</p>
          {facebokLoginEnabled ? (
            <a
              href={`${apiHost}/api/v2/auth/facebook?webInstanceToken=${get(webInstance, 'webInstanceToken')}&cartAccessToken=${encodeURIComponent(get(cart, "accessToken", ''))}&frontendReturnUrl=${host}/api/lib/v1/auth/oauth?backUrl=${router.asPath}`}
              className={`btn btn-yellow ${styles.btn}`}
            >
              {t("Registrovať sa pomocou Facebook")}
            </a>
          ) : null}
          {googleLoginEnabled ? (
            <a
            href={`${apiHost}/api/v2/auth/google?webInstanceToken=${get(webInstance, 'webInstanceToken')}&cartAccessToken=${encodeURIComponent(get(cart, "accessToken", ''))}&frontendReturnUrl=${host}/api/lib/v1/auth/oauth?backUrl=${router.asPath}`}
            className={`btn btn-yellow ${styles.btn}`}
            >
              {t("Registrovať sa cez Google")}
            </a>
          ) : null}
          <RegisterForm />
        </div>
      </div>
      <div className={`${styles.col} ${styles.first} ${styles.signin}`}>
        <div>
          <h3>{t("Už ste zaregistrovaný?")}</h3>
          <p>{t("Prihláste sa do svojho účtu, na prihlásenie použite svoj email a heslo")}</p>
          <Link href="/prihlasenie" as={`/prihlasenie`}>
            <a className={`btn btn-white`}>
              {t("Prihláste sa")}
            </a>
          </Link>
        </div>
      </div>
    </div>
  );
};

export const getServerSideProps = withSession(async function ({ req, res, locale }) {
  const user = req.session.get(USER_CONSTANT);
  const cart = req.session.get(CART_CONSTANT);

  return {
    props: { 
      user: user ? user : null,
      cart: cart ? cart : null,
      apiHost: reqApiHost(),
      host: reqGetHost(req),
      ...(await fetchTranslations(locale))
    },
  };
});

export default Register;
